/**
 * @Description 周边配套
 */

import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import Search from './components/Search';
import TableList from './components/TableList';
import { useMethods } from '@lhb/hook';
import { youthShareAroundPage, youthAroundPage } from '@/common/api/youth';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { isArray } from '@lhb/func';
import Community from './components/Community';
import { BUSINESS_AREA_KEY, COMMUNITY_KEY } from '../../ts-config';
import BusinessArea from './components/BusinessArea';


export interface SurroundProps {
  detail?: any;
  setSurroundingChecked?: any;
  setSurroundingOptions?: any;
  curDetail:any;
  setCurDetail:any;
  isShare?: boolean;
  shareParams?: any;
  modelConfigId: any;
  allowSurroundTitleJumpDetail?: any;
}

const Surround: FC<SurroundProps> = ({
  detail,
  setSurroundingChecked,
  setSurroundingOptions,
  // curSurroundDetail,
  setCurDetail,
  isShare,
  shareParams,
  modelConfigId,
  allowSurroundTitleJumpDetail,
  ...props
}) => {
  const mainHeight = 521;
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新
  const [tableLoading, setTableLoading] = useState<boolean>(true);// 是否需要当前页刷新
  const [isNoData, setIsNodata] = useState<boolean>(false);// 是否没数据
  const [modColumn, setModColumn] = useState<any>({
    value: 'liveNum',
    label: '居住人口'
  });// 表头修改
  const [currentCommercialIndex, setCurrentCommercialIndex] = useState<string>('');// 业态key值

  useEffect(() => {
    if (Object.keys(filters).length && Object.keys(detail).length) {
      setTableLoading(false);
      setSurroundingChecked && setSurroundingChecked(filters);
    }
  }, [filters, detail]);

  const methods = useMethods({

    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      let _params: any = {};
      _params = {
        page: params.page,
        size: params.size,
        poiSearchType: 1,
        radius: filters.distance,
        lat: detail.lat,
        lng: detail.lng,
        aoiTypeCategoryId: filters.aoiTypeCategoryId,
        secondAoiType: filters.secondAoiType,
        cityName: detail.cityName,
        modelConfigId,
        modelClusterId: detail.id,
      };
      const api = isShare ? youthShareAroundPage : youthAroundPage;
      if (isShare) {
        _params.tenantId = shareParams?.tenantId;
        _params.userId = shareParams?.employeeId;
      }

      if (!_params.lat || !_params.lng) {
        return {
          dataSource: [],
          count: 0,
        };
      }

      const data = await api(_params, false);
      let { objectList } = data;
      if (!isArray(objectList)) {
        objectList = [];
      }
      const isCommunity = !!objectList?.find(item => item?.isCommunity);
      // isCommunity判断是否小区
      setModColumn(isCommunity ? { value: 'liveNum', label: '居住人口' } : { value: 'address', label: '地址' });
      const dataSource = objectList.map((item, index) => {
        item.index = (params.page - 1) * params.size + index + 1;
        return item;
      });
      return {
        dataSource,
        count: data.totalNum,
      };

    },
  });
  /** 是否是小区 */
  const isCommunity = useMemo(() => {
    return String(currentCommercialIndex) === COMMUNITY_KEY;
  }, [currentCommercialIndex]);

  // 是否是商业
  const isBusinessArea = useMemo(() => {
    return String(currentCommercialIndex) === BUSINESS_AREA_KEY;
  }, [currentCommercialIndex]);
  return isNoData ? <></> : (
    <div className={styles['store']} >
      <V2Title divider type='H2' text={`周边配套`}/>
      <Search
        onSearch={methods.onSearch}
        detail={detail}
        setCurDetail={setCurDetail}
        setIsNodata={setIsNodata}
        setSurroundingOptions={setSurroundingOptions}
        isShare={isShare}
        shareParams={shareParams}
        currentCommercialIndex={currentCommercialIndex}
        setCurrentCommercialIndex={setCurrentCommercialIndex}
      />
      {!tableLoading ? (
        isCommunity || isBusinessArea ? <>
          {
            isBusinessArea && (
              <BusinessArea
                detail={detail}
                filters={filters}
                setCurDetail={setCurDetail}
                mainHeight={mainHeight}
                shareParams={shareParams}
                isShare={isShare}
                modelConfigId={modelConfigId}
                allowSurroundTitleJumpDetail={allowSurroundTitleJumpDetail}
              />
            )
          }
          {
            isCommunity && (
              <Community
                isShare={isShare}
                shareParams={shareParams}
                detail={detail}
                filters={filters}
                curDetail={props?.curDetail}
                setCurDetail={setCurDetail}
                mainHeight={mainHeight}
                modelConfigId={modelConfigId}
              />
            )
          }
        </> : (
          <TableList
            mainHeight={mainHeight}
            filters={filters}
            onFetch={methods.loadData as any}
            refreshCurrent={refreshCurrent}
            modColumn={modColumn}
            rowClassName={(record) => {
            // 与数据部门确定，会出现名字相同的数据，但是其他字段会不同
              const isSame = record.name === props?.curDetail?.name && record.lng === props?.curDetail?.lng && record.lat === props?.curDetail?.lat;
              return isSame ? 'checked pointer' : 'pointer';
            }}
            onRow={record => {
              return {
                onClick: () => {
                  setCurDetail(record);
                // bigdataFn('6040c893-8283-4852-90af-421553b6bb5a', '详情-周边配套-点击列表', '点击了详情-周边配套-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
                }, // 点击行
              };
            }}
            onPaginationChange={() => {
            // bigdataFn('aea6572d-e826-424d-9ba0-ef71e7b79852', '详情-周边配套-列表跳页', '点击了详情-周边配套-列表跳页', { op_block: '开店区域-详情页', op_event: ``, });
            }}
          />
        )
      ) : ''}
    </div>
  );
};

export default Surround;
